<!-- Barre : zone sûre, « ‹ Retour » à gauche, actions de la page à droite -->
<div data-testid="page-header-bar"
  [class.sticky]="sticky" [class.top-0]="sticky" [class.z-20]="sticky"
  [class.bg-vw-bg]="sticky && look === 'light'" [class.bg-vw-surface]="sticky && look === 'white'">
  @if (safeArea) {
    <vw-header-padding-safe-area [look]="look"></vw-header-padding-safe-area>
  }
  <div class="flex min-h-target items-center justify-between gap-2" [class.px-2]="!inset" [class.-mx-2]="inset">
    <button type="button" data-testid="page-header-back"
      class="flex min-h-target min-w-target shrink-0 items-center gap-1 rounded-pill px-2 text-body font-semibold text-vw-primary active:bg-vw-surface-sunk"
      [attr.aria-label]="backLabel || ('common.back' | translate)" (click)="onBack()">
      <svg class="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
      <!-- La graisse se pose sur le span : la feuille globale remet les span à 400. -->
      <span class="font-semibold">{{ backLabel || ('common.back' | translate) }}</span>
    </button>
    <div class="flex min-w-0 items-center gap-1">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>

@if (title) {
  <div class="pb-4 pt-1" [class.px-4]="!inset">
    <h1 class="font-display text-title-l text-vw-ink" data-testid="page-header-title">{{ title }}</h1>
    @if (subtitle) {
      <p class="pt-1 text-body-s text-vw-muted" data-testid="page-header-subtitle">{{ subtitle }}</p>
    }
  </div>
}
